import { render, staticRenderFns } from "./RegisterBox.vue?vue&type=template&id=20785ab6&scoped=true&"
import script from "./RegisterBox.vue?vue&type=script&lang=js&"
export * from "./RegisterBox.vue?vue&type=script&lang=js&"
import style0 from "./RegisterBox.vue?vue&type=style&index=0&id=20785ab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20785ab6",
  null
  
)

export default component.exports